import {
  DetailListItemTitle,
  DetailListItemLabel,
  DetailListItemRight,
  LinkInner,
  Meta,
} from 'ui/Details';
import Amount from '@tymate/sergic/components/Amount';
import CardLinkArrow from 'components/CardLinkArrow';
import { getParcelsSummary } from 'utils';
import { useTranslation } from 'react-i18next';
import { isFuture } from 'date-fns';

const ContractCard = ({ contract, isLinking, readOnly }) => {
  const { t } = useTranslation();
  const {
    customerReferenceNumber,
    parcels,
    totalAmount,
    pendingAmount,
  } = contract;

  const shouldShowDueAmount =
    Boolean(contract?.dueDate) &&
    isFuture(new Date(contract?.dueDate)) &&
    Boolean(contract?.pendingAmount);

  return (
    <LinkInner>
      <Meta>
        <DetailListItemTitle>
          {t('account:account')} {customerReferenceNumber}
        </DetailListItemTitle>
        <DetailListItemLabel small>
          {getParcelsSummary(parcels)}
        </DetailListItemLabel>
      </Meta>

      {(Boolean(totalAmount) || totalAmount === 0) && (
        <DetailListItemRight>
          <Amount
            amount={
              shouldShowDueAmount
                ? (totalAmount + pendingAmount) / 100
                : totalAmount / 100
            }
          />
        </DetailListItemRight>
      )}

      {!readOnly && <CardLinkArrow />}
    </LinkInner>
  );
};

export default ContractCard;
